import { useEffect } from 'react'

const CalendlyEmbed = ({ url }) => {
  useEffect(() => {
    const head = document.querySelector('head')
    const script = document.createElement('script')
    script.setAttribute(
      'src',
      'https://assets.calendly.com/assets/external/widget.js',
    )
    head.appendChild(script)
  }, [])

  return (
    <div
      className="calendly-inline-widget"
      data-url={url + '?hide_landing_page_details=1&hide_event_type_details=1'}
      style={{
        height: 650,
        minHeight: 650,
        width: '100%',
        backgroundColor: 'white'
      }}
    ></div>
  )
}

export default CalendlyEmbed